import { JSX, createContext, useContext } from 'solid-js';
import usePresenter from '~/framework/hooks/usePresenter';
import { LeasePresenter } from '~/presenters/LeasePresenter';

interface DeactivatedLeasesType {
  isLeaseDeactivated: (leaseId?: string) => boolean;
}

interface LeasesStatusProps {
  children: JSX.Element;
}

const DeactivatedLeasesContext = createContext<DeactivatedLeasesType>();

export const DeactivatedLeases = (props: LeasesStatusProps) => {
  const { model: leases } = usePresenter(LeasePresenter);

  const getDeactivatedLeaseById = (leaseId?: string) => {
    return leases()?.deactivatedLeases.find((lease) => lease.id === leaseId);
  };

  const isLeaseDeactivated = (leaseId?: string) => {
    return Boolean(getDeactivatedLeaseById(leaseId));
  };

  return <DeactivatedLeasesContext.Provider value={{ isLeaseDeactivated }}>{props.children}</DeactivatedLeasesContext.Provider>;
};

export const useDeactivatedLeases = () => {
  const context = useContext(DeactivatedLeasesContext);
  if (!context) {
    throw new Error('useDeactivatedLeases must be used within a DeactivatedLeasesContext');
  }
  return context;
};
